import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-share', function(e) {
        if (!((e.target).closest('.js-share-tooltip')) && !((e.target).closest('.js-share-close'))) {   
            $(this).find('.js-share-tooltip').toggleClass('show');
        }
    });
    $(document).on('click', '.js-share-close', function() {
        $('.js-share-tooltip').removeClass('show');
    });
    $('body').on('click', function(e) {
        if (!((e.target).closest('.js-share-tooltip')) && !((e.target).closest('.js-share'))) {
            $('.js-share-tooltip').removeClass('show');
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-share.js